import { createSlice } from '@reduxjs/toolkit';
import { fetchFacility } from '../actions/facilityActions';

const initialState = {
  facility: [],
  loading: false,
  error: null,
//   status: 'idle'
};

const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacility.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.facility = action.payload;
      })
      .addCase(fetchFacility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});


// Selectors
export const getFacility = (state) => state.facility.facility;
export const getFacilityLoading = (state) => state.facility.loading;
export const getFacilityError = (state) => state.facility.error;

export default facilitySlice.reducer;
